import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }
  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="h2" components={components}>{`7. Stranger Things Intro Creator`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`7.1.`}</MDXTag>{` This website is not related or to Netflix. The music and the Stranger Things logo are copyrights of Netflix.`}</MDXTag>
<MDXTag name="h2" components={components}>{`8. Video customizations`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`8.1.`}</MDXTag>{` The following pricing plans are available:`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="strong" components={components} parentName="li">{`HD Video`}</MDXTag>{` (1280 x 720, MP4 File): pay at least `}<MDXTag name="strong" components={components} parentName="li">{`10 US Dollars`}</MDXTag>{`.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="strong" components={components} parentName="li">{`Full HD Video`}</MDXTag>{` (1920 x 1080, MP4 File): pay at least `}<MDXTag name="strong" components={components} parentName="li">{`12 US Dollars`}</MDXTag>{`. `}<MDXTag name="em" components={components} parentName="li">{`(Most Popular)`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="strong" components={components} parentName="li">{`4K HD Video`}</MDXTag>{` (3840 x 2060, MP4 File): pay at least `}<MDXTag name="strong" components={components} parentName="li">{`15 US Dollars`}</MDXTag>{`. `}<MDXTag name="em" components={components} parentName="li">{`(Most Quality)`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`8.2.`}</MDXTag>{` You can see a sample of a video rendered here: `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "https://youtu.be/Q0eEXKyA540"
        }}>{`https://youtu.be/Q0eEXKyA540`}</MDXTag></MDXTag>
           </MDXTag>;
  }
}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      